import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { Category } from '@/domain/impact-co2/entities/question.entity';

// TODO REFACTOR : TLDR: remove this hard coded list : make it automatic
// this is used for compute the completion of external questions
// it would be better to use the same list for (question to display and question to use for completion)

type CategoriesByScope = {
  [key in Scope]: Category[];
};

const CATEGORIES: CategoriesByScope = {
  '': [],
  // FESTIVAL
  TEAM: ['MOBILITY', 'CATERING_MEAL', 'CATERING_BEVERAGE', 'ACCOMMODATION'],
  ARTISTS: ['MOBILITY', 'CATERING_MEAL', 'CATERING_BEVERAGE', 'ACCOMMODATION'],
  PUBLIC_SUPPLIER: ['CATERING_MEAL', 'CATERING_BEVERAGE'],
  SITE: [
    'BUILDING',
    'ENERGY',
    'GENERATOR',
    'WATER',
    'EQUIPMENT',
    'NON_RECYCLABLE_WASTE',
    'RECYCLABLE_WASTE',
  ],
  PUBLIC: ['MOBILITY_PUBLIC', 'ACCOMMODATION_PUBLIC'],
  // FESTIVAL CATEGORIES
  'TEAM-MOBILITY': ['MOBILITY'],
  'TEAM-CATERING': ['CATERING_MEAL', 'CATERING_BEVERAGE'],
  'TEAM-ACCOMMODATION': ['ACCOMMODATION'],
  'ARTISTS-MOBILITY': ['MOBILITY'],
  'ARTISTS-CATERING': ['CATERING_MEAL', 'CATERING_BEVERAGE'],
  'ARTISTS-ACCOMMODATION': ['ACCOMMODATION'],
  'ARTISTS-CARGO': ['CARGO'],
  'SITE-ENERGY-WATER-WASTE': [
    'ENERGY',
    'GENERATOR',
    'WATER',
    'RECYCLABLE_WASTE',
    'NON_RECYCLABLE_WASTE',
  ],
  'SITE-EQUIPMENT-CARGO': ['EQUIPMENT', 'CARGO'],
  'SITE-BUILDING': ['BUILDING'],
  // VENUE-STRUCTURE
  'VENUE-STRUCTURE-SITE': [
    'SCENOGRAPHY_NO_RECYCLABLE',
    'SCENOGRAPHY_RECYCLABLE',
    'OFFICE_SUPPLIES_NEW',
    'OFFICE_SUPPLIES_REFURBISH',
    'BUILDING_HEATING',
    'ENERGY',
    'GENERATOR',
    'WATER',
    'RECYCLABLE_WASTE',
    'NON_RECYCLABLE_WASTE',
    'EQUIPMENT',
  ],
  'VENUE-STRUCTURE-TEAM': ['TEAM_MOBILITY', 'CATERING_MEAL'],
  // VENUE-STUCTURE CATEGORIES
  'VENUE-STRUCTURE-TEAM-TRANSPORT': ['TEAM_MOBILITY'],
  'VENUE-STRUCTURE-TEAM-CATERING': ['CATERING_MEAL'],
  'VENUE-STRUCTURE-SITE-SCENOGRAPHY': [
    'SCENOGRAPHY_NO_RECYCLABLE',
    'SCENOGRAPHY_RECYCLABLE',
  ],
  'VENUE-STRUCTURE-SITE-MATERIAL': [
    'OFFICE_SUPPLIES_NEW',
    'OFFICE_SUPPLIES_REFURBISH',
  ],
  'VENUE-STRUCTURE-SITE-BUILDING': ['BUILDING_HEATING'],
  'VENUE-STRUCTURE-SITE-ENERGY': ['ENERGY', 'GENERATOR'],
  'VENUE-STRUCTURE-SITE-WATER': ['WATER'],
  'VENUE-STRUCTURE-SITE-WASTE': ['RECYCLABLE_WASTE', 'NON_RECYCLABLE_WASTE'],
  'VENUE-STRUCTURE-SITE-EQUIPMENT': ['EQUIPMENT'],
  'VENUE-STRUCTURE-PUBLIC': ['CATERING_MEAL', 'CATERING_BEVERAGE', 'DIGITAL'],
  'VENUE-STRUCTURE-PUBLIC-CATERING': ['CATERING_MEAL', 'CATERING_BEVERAGE'],
  'VENUE-STRUCTURE-PUBLIC-DIGITAL': ['DIGITAL'],
  // VENUE-DATES
  'VENUE-DATES-ARTISTS': [
    'MOBILITY',
    'CATERING_MEAL',
    'CATERING_BEVERAGE',
    'ACCOMMODATION',
    'CARGO',
    'EQUIPMENT',
  ],
  // VENUE-DATES CATEGORIES
  'VENUE-DATES-ARTISTS-MOBILITY': ['MOBILITY'],
  'VENUE-DATES-ARTISTS-CATERING': ['CATERING_MEAL', 'CATERING_BEVERAGE'],
  'VENUE-DATES-ARTISTS-ACCOMMODATION': ['ACCOMMODATION'],
  'VENUE-DATES-ARTISTS-CARGO': ['CARGO', 'EQUIPMENT'],
  // SURVEY CATEGORIES
  'SURVEY-MOBILITY-ACCOMMODATION': ['MOBILITY_PUBLIC', 'ACCOMMODATION_PUBLIC'],
};

export function getCategoriesToFillForScope(scope: Scope): Category[] {
  return CATEGORIES[scope];
}
